import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account, PositivePayCheckFile } from "model";
import TASPositivePayCreateTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayCreateTemplatePage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayImportChecksColumn1Selected
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks" capture group.
 */
export default function CapturePositivePayImportChecksColumn1Selected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    defaultData.selectedColumns = defaultData.selectedColumns.reduce((acc, item) => {
        if(item.id === "0") {
            acc.push({ id: "0", value: { id: "1", value: "Payee", class: "payee", isSelected: true } });
        } else {
            acc.push(item);
        }
        return acc;
    }, []);

    defaultData.mapColumns = defaultData.mapColumns.reduce((acc, item) => {
        if(item.id === "1") {
            item.isSelected = true;
        }
        acc.push(item);
        return acc;
    }, []);

    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "checkTemplate", "positivePayCheckFile" ], PositivePayCheckFile.initByID("0"))
    .update([ "checkTemplate", "name" ], "Sample")
    .submit();
    
    const ui = BCMSStateManagerCRUD.init( getDefaultUI(data.checkTemplate))
    .update([ "checkTemplate", "showFilePreview", "isActive" ], true)
    .submit();

    return <TASPositivePayCreateTemplatePage data={ data } ui={ ui } />;
}